import React, { useState } from 'react';
import {
  ArrowUpRight, CookingPot, Utensils, Flame, ChefHat, Wind,
  Microwave, Soup, Package, Blend,
} from 'lucide-react';
import { popularProducts } from '../mock';
import useReveal from '../hooks/useReveal';

const iconMap = {
  CookingPot, Utensils, Flame, ChefHat, Wind, Microwave, Soup, Package, Blender: Blend,
};

const Products = () => {
  useReveal();
  const [active, setActive] = useState(popularProducts[0].id);
  const activeBrand = popularProducts.find((p) => p.id === active);

  return (
    <section id="products" className="py-16 lg:py-24 paper-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.32em] font-semibold text-[#F58220] mb-4">
            Bestsellers
          </div>
          <h2 className="h-display uppercase text-[40px] md:text-[64px] text-[#1a1410]">
            Popular <span className="text-[#F58220]">Products</span>
          </h2>
          <p className="mt-5 text-[15px] text-[#4D4D4D]">
            Explore best-loved picks across our partner brands.
          </p>
        </div>

        <div className="reveal flex flex-wrap gap-3 justify-center mb-12">
          {popularProducts.map((b) => (
            <button
              key={b.id}
              onClick={() => setActive(b.id)}
              className={`px-5 py-2.5 rounded-full text-[11px] uppercase tracking-[0.22em] font-bold border transition-all duration-400 ${
                active === b.id
                  ? 'bg-[#F58220] text-white border-[#F58220]'
                  : 'bg-transparent text-[#4D4D4D] border-[#E9D6C1] hover:border-[#F58220] hover:text-[#F58220]'
              }`}
            >
              {b.brand}
            </button>
          ))}
        </div>

        <div className="grid lg:grid-cols-[280px_1fr] gap-8 items-start">
          {/* Active brand card */}
          <div className="reveal bg-[#1a1410] text-[#F7F4EA] rounded-2xl p-8 text-center relative overflow-hidden">
            <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#F58220]/20 blur-3xl" />
            <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full bg-[#F58220]/10 blur-3xl" />
            <div className="relative">
              <div className="w-24 h-24 mx-auto rounded-2xl bg-[#F58220] flex items-center justify-center mb-6 shadow-2xl">
                <span className="h-display text-[30px] text-white">{activeBrand.brand.charAt(0)}</span>
              </div>
              <div className="text-[10px] uppercase tracking-[0.28em] font-semibold text-[#F58220] mb-2">
                Brand
              </div>
              <div className="h-display uppercase text-[28px]">{activeBrand.brand}</div>
              <div className="text-[12px] text-[#F7F4EA]/70 mt-3">{activeBrand.tagline}</div>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="mt-7 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] font-bold text-[#F7F4EA] border-b-2 border-[#F58220] pb-1 hover:text-[#F58220] transition-colors"
              >
                View All <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Product items */}
          <div className="grid sm:grid-cols-2 gap-5">
            {activeBrand.items.map((it, i) => {
              const Icon = iconMap[it.icon] || CookingPot;
              return (
                <div
                  key={`${activeBrand.id}-${i}`}
                  className="group bg-white rounded-2xl overflow-hidden card-lift border border-[#E9D6C1]"
                >
                  <div className="aspect-[4/3] flex items-center justify-center relative overflow-hidden"
                    style={{ background: 'radial-gradient(circle at 50% 50%, #FFF6EA 0%, #F7F4EA 70%)' }}
                  >
                    {/* Subtle orbit rings */}
                    <div className="absolute w-40 h-40 rounded-full border border-[#F58220]/12" />
                    <div className="absolute w-56 h-56 rounded-full border border-[#F58220]/8" />
                    <div className="relative w-24 h-24 rounded-2xl bg-white shadow-lg flex items-center justify-center border border-[#E9D6C1] group-hover:scale-110 transition-transform duration-500">
                      <Icon className="w-12 h-12 text-[#F58220]" strokeWidth={1.4} />
                    </div>
                  </div>
                  <div className="p-6 flex items-center justify-between">
                    <div>
                      <div className="text-[10px] uppercase tracking-[0.26em] font-semibold text-[#F58220] mb-1">
                        {activeBrand.brand}
                      </div>
                      <div className="font-semibold text-[17px] text-[#1a1410]">{it.name}</div>
                    </div>
                    <div className="w-10 h-10 rounded-full bg-[#F7F4EA] flex items-center justify-center group-hover:bg-[#F58220] transition-colors duration-500">
                      <ArrowUpRight
                        className="w-4 h-4 text-[#1a1410] group-hover:text-white transition-colors duration-500"
                        strokeWidth={2}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
